import React from 'react';
import { Globe, Smartphone, ShoppingCart, TrendingUp, Search, Code } from 'lucide-react';
import { motion } from 'framer-motion';
import ServiceCard from '../ServiceCard';
import VisualCanvas from './VisualCanvas';

const ServicesSection = () => {
    const coreServices = [
        { title: 'Website Development', description: 'Custom, responsive, and high-performance websites tailored to your business needs.', icon: Globe, path: '/services/website-development' },
        { title: 'Android App Development', description: 'Cutting-edge Android applications with seamless user experiences and modern features.', icon: Smartphone, path: '/services/android-development' },
        { title: 'Coding Courses', description: 'Master web development, app development, and UI/UX through our professional courses.', icon: Code, path: '/services/coding-courses' },
        { title: 'Digital Marketing', description: 'Data-driven marketing strategies to grow your brand presence and reach more customers.', icon: TrendingUp, path: '/services/digital-marketing' },
        { title: 'SEO Optimization', description: 'Boosting your search rankings to ensure your business gets found by the right audience.', icon: Search, path: '/services/seo' },
        { title: 'E-commerce Solutions', description: 'Robust online stores that drive sales and provide secure shopping for customers.', icon: ShoppingCart, path: '/services/ecommerce' }
    ];

    return (
        <section className="py-16 md:py-24 bg-white border-y border-slate-100 relative overflow-hidden">
            {/* Background 3D */}
            <div className="absolute inset-x-0 top-0 bottom-0 opacity-[0.03] pointer-events-none">
                <VisualCanvas type="box" color="#2563eb" height="100%" />
            </div>

            <div className="container mx-auto px-4 md:px-6 relative z-10">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.1 }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-10 md:mb-12"
                >
                    <span className="text-primary font-black uppercase tracking-[0.4em] text-[9px] md:text-xs mb-2 block">What We Offer</span>
                    <h2 className="text-xl md:text-3xl lg:text-4xl font-black text-slate-900 tracking-tight">Core <span className="text-gradient">Services</span></h2>
                </motion.div>

                <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
                    {coreServices.map((service, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 15 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.1 }}
                            transition={{ duration: 0.4, delay: index * 0.05 }}
                        >
                            <ServiceCard {...service} index={index} />
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServicesSection;
